<template>
  <v-container>
    <v-card-text>
      <!-- 1 -->
      <h1 class="warning-500">1 Buttons & Chips</h1>
      <ButtonChips></ButtonChips>

      <!-- 2 -->
      <h1 class="mt-10 warning-500">2 Form Controls</h1>
      <FormControls></FormControls>

      <!-- 3 -->
      <h1 class="mt-10 warning-500">3 Navigation</h1>
      <Navigation></Navigation>

      <!-- 4 -->
      <h1 class="mt-10 warning-500">4 Form inputs</h1>
      <FormInputs></FormInputs>

      <!-- 5 -->
      <h1 class="mt-10 warning-500">5 Selection</h1>
      <Selection></Selection>

      <!-- 6 -->
      <h1 class="h1 mt-16 warning-500">6 Color & Typography</h1>
      <ColorTypography></ColorTypography>

      <!-- Other -->
      <h1 class="mt-16 warning-500">Other</h1>
      <Other></Other>

      <!--  -->
    </v-card-text>
  </v-container>
</template>

<script>
import ButtonChips from '@/views/Z-UISpec/Z-1_ButtonChips.vue';
import FormControls from '@/views/Z-UISpec/Z-2_FormControls.vue';
import Navigation from '@/views/Z-UISpec/Z-3_Navigation.vue';
import FormInputs from '@/views/Z-UISpec/Z-4_FormInputs.vue';
import Selection from '@/views/Z-UISpec/Z-5_Selection.vue';
import ColorTypography from '@/views/Z-UISpec/Z-6_ColorTypography.vue';
import Other from '@/views/Z-UISpec/Z-9_Other.vue';

export default {
  components: {
    ButtonChips,
    FormControls,
    Navigation,
    FormInputs,
    Selection,
    ColorTypography,
    Other,
  },
  name: 'HelloWorld',
};
</script>
